import React from "react";
import { GLBANOTICELINK } from "Utils/EnvVars";
import { faro } from "@grafana/faro-react";
import { Box, Link } from "@mui/material";
import { PRIVACY_POLICY_LINK, TERMS_OF_SERVICE_LINK } from "Utils/Constants";

export default function TermsAndConditions({
  buttonText = "submit",
  isCashier,
}) {
  const styleClass = isCashier
    ? "cashier-termsAndConditions"
    : "termsAndConditions";
  const linkClick = (link) => faro.api.pushEvent(`User clicked on ${link}`);

  return (
    <Box
      className={styleClass}
      sx={{
        width: "100vw",
        display: "flex",
        position: isCashier ? "relative" : "fixed",
        marginTop: "50px",
        bottom: 0,
        left: 0,
        flexDirection: "column",
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          width: "100%",
          padding: isCashier
            ? "16px var(--spacing-4xl) 16px var(--spacing-2xl)"
            : "16px var(--spacing-4xl)",

          background: "var(--color-surface-background-secondary)",
          textAlign: "center",
          fontSize: "var(--caption-size-medium)",
          fontWeight: 400,
        }}
      >
        By clicking {buttonText.toUpperCase()}, I agree to the{" "}
        <Link
          onClick={() => linkClick("Terms & Conditions")}
          href={TERMS_OF_SERVICE_LINK}
          sx={{
            color: "var(--color-text-link)",
            fontWeight: 700,
          }}
        >
          Terms & Conditions
        </Link>
        ,{" "}
        <Link
          onClick={() => linkClick("Privacy Notice")}
          href={PRIVACY_POLICY_LINK}
          sx={{
            color: "var(--color-text-link)",
            fontWeight: 700,
          }}
        >
          Privacy Notice
        </Link>
        , and{" "}
        <Link
          onClick={() => linkClick("GLBA Notice")}
          href={GLBANOTICELINK}
          sx={{
            color: "var(--color-text-link)",
            fontWeight: 700,
          }}
        >
          GLBA Notice
        </Link>
        .
        {isCashier && (
          <Box sx={{ marginTop: "12px", fontSize: "14px" }}>
            Secure deposit powered by PavilionPayments
          </Box>
        )}
      </Box>
    </Box>
  );
}
